export default __webpack_public_path__ + "static/media/neckbeard.3f771f57.png";